module.exports = __webpack_public_path__ + "static/media/gears-selector-color.f3387cd1.png";